<app-header></app-header>
<div class="content_wrapper">

    <!--Header summary-->
    <div class="summary-head">
        <div class="wrapper">
            <span class="heading-period"><span>Pick a date range and period :</span></span>
            <div class="datepicker-wrapper">
                <div class="periodpicker-wrapper">
                    <!--                    <button class="btn-da btn" type="button">Days</button>
                                        <button class="btn-grey btn" type="button">Weeks</button>
                                        <button class="btn-grey btn" type="button">Months</button>-->
                </div>
                <div class="popover-wrapper">
                    <input type="text"
                           ngxDaterangepickerMd
                           [(ngModel)]="selected"
                           [alwaysShowCalendars]="alwaysShowCalendars"
                           [ranges]="ranges"
                           [showClearButton]="true"
                           [showCancel]="true"
                           [linkedCalendars]="true"
                           [locale]="{applyLabel: 'Apply'}"
                           (datesUpdated)="datesUpdated($event)"
                           [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
                           [showRangeLabelOnInput]="showRangeLabelOnInput"
                           class="form-control"/>
                    <!--                    <button class="popover-toggle btn"><i class="fa fa-calendar-o"></i>
                                            <span class="pop-text"><span>Last 30 days</span></span><i class="fa fa-angle-down"></i></button>-->
                </div>
            </div>
            <!--<button (click)="update_datepicker_latest()" class="submit-mention btn" type="button">Latest Mentions</button>-->
        </div>
    </div>

    <!--first row-->
    <div class="row">
        <div class="col-md-6">
            <div class="summary-mentions">
                <div class="spinner-border popular" [style.display]="popularLoading ? 'block' : 'none'"></div>
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" data-toggle="tab" id="home-tab" href="#home" role="tab"><span><i class="fa fa-comment-o"></i></span>The most popular mentions</a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" data-toggle="tab" id="latest-mentions-tab"  href="#latest-mentions" role="tab"><span><i class="fa fa-star-o"></i></span>Latest Mentions</a>
                    </li>
                </ul>

                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                        <div class="pop-content">
                            <div class="pre-loader">
                                <ul>
                                    <li *ngFor="let mention of popular_mentions; let i = index" [style.display]="can_show_mention(mention.id, mention.profile_id)">
                                        <div class="mention-wrapper">
                                            <div class="mention-header">
                                                <div class="img-wrap">
                                                    <img src="{{get_social_icon(mention.mchannel)}}">
                                                </div>
                                                <div class="content-mention">
                                                    <div class="mention_meta">
                                                        <span class="mention_meta_title">{{mention.name}}</span>
                                                        <span class="date"><i class="fa fa-calendar"></i>{{change_date_format(mention.pub_datetime, 'YYYY-MM-DD hh:mm a')}}</span>
                                                    </div>
                                                    <div class="mention_meta">
                                                        <span *ngIf="mention.profile_type_name == 'reddit'" class="mention_meta_src">
                                                            <i class="fa fa-share-alt "></i><a target="_blank" href="https://www.reddit.com{{mention.link}}">www.reddit.com</a>
                                                        </span>
                                                        <span *ngIf="mention.profile_type_name != 'reddit'" class="mention_meta_src">
                                                            <i class="fa fa-share-alt "></i><a target="_blank" href="{{mention.link}}">{{mention.link.split("/")[2]}}</a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="content_bottom">{{mention.description | slice:0:100}}..</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="panel-footer"><a [routerLink]="['/mention']" [queryParams]="{ id: project_id }" class="more-results"><span>More mentions</span></a></div>
                        </div>
                    </div>

                    <!---latest-tab--->

                    <div class="tab-pane fade" id="latest-mentions" role="tabpanel" aria-labelledby="latest-mentions-tab">
                        <div class="latest-content">
                            <div class="pre-loader latest">
                                <ul>
                                    <li *ngFor="let mention of latest_mentions; let i = index" [style.display]="can_show_mention(mention.id, mention.profile_id)">
                                        <div class="mention-wrapper">
                                            <div class="mention-header">
                                                <div class="img-wrap">
                                                    <img src="{{get_social_icon(mention.mchannel)}}">
                                                </div>
                                                <div class="content-mention">
                                                    <div class="mention_meta">
                                                        <span class="mention_meta_title">{{mention.name}}</span>
                                                        <span class="date"><i class="fa fa-calendar"></i>{{change_date_format(mention.pub_datetime, 'YYYY-MM-DD hh:mm a')}}</span>
                                                    </div>
                                                    <div class="mention_meta">
                                                        <span *ngIf="mention.profile_type_name == 'reddit'" class="mention_meta_src">
                                                            <i class="fa fa-share-alt "></i><a target="_blank" href="https://www.reddit.com{{mention.link}}">www.reddit.com</a>
                                                        </span>
                                                        <span *ngIf="mention.profile_type_name != 'reddit'" class="mention_meta_src">
                                                            <i class="fa fa-share-alt "></i><a target="_blank" href="{{mention.link}}">{{mention.link.split("/")[2]}}</a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="content_bottom">{{mention.description | slice:0:100}}..</p>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                            <div class="panel-footer"><a [routerLink]="['/mention']" [queryParams]="{ id: project_id }" class="more-results"><span>More mentions</span></a></div>
                        </div>
                    </div>

                </div>


            </div>
        </div>

        <div class="col col-md-6">
            <div class="summary-graph">
                <div class="summary-title">
                    <i class="fa fa-bookmark-o"></i><h2 class="">Summary</h2>
                </div>
                <!--tbl sec-->
                <div class="spinner-border" [style.display]="summaryLoading ? 'block' : 'none'"></div>
                <div class="summary-tbl">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <a [routerLink]="['/mention']" [queryParams]="{ id: project_id }">
                                        <div class="diff-sec">
                                            <h3>Mentions</h3>
                                            <h4 [innerHtml]="summary.all"></h4>
                                            <!--<p>-5249(-22%)</p>-->
                                        </div>
                                    </a>
                                </td>
                                <td>
                                    <a [routerLink]="['/mention']" [queryParams]="{ id: project_id, channels: 'sm' }">
                                        <div class="diff-sec">
                                            <h3>Sm Mentions</h3>
                                            <h4 [innerHtml]="summary.sm"></h4>
                                            <!--<p>-5249(-22%)</p>-->
                                        </div>
                                    </a>
                                </td>
                                <td>
                                    <a [routerLink]="['/mention']" [queryParams]="{ id: project_id, sentiment: '2' }">
                                        <div class="diff-sec">
                                            <h3>Neutral</h3>
                                            <h4 [innerHtml]="summary.interactions"></h4>
                                            <!--<p>-5249(-22%)</p>-->
                                        </div>
                                    </a>
                                </td>
                                <td>
                                    <a [routerLink]="['/mention']" [queryParams]="{ id: project_id, sentiment: '1' }">
                                        <div class="diff-sec">
                                            <h3>Positive</h3>
                                            <h4 [innerHtml]="summary.positive"></h4>
                                            <!--<p>-5249(-22%)</p>-->
                                        </div>
                                    </a>
                                </td>
                                <td>
                                    <a [routerLink]="['/mention']" [queryParams]="{ id: project_id, sentiment: '-1' }">
                                        <div class="diff-sec">
                                            <h3>Negative</h3>
                                            <h4 [innerHtml]="summary.negative"></h4>
                                            <!--<p>-5249(-22%)</p>-->
                                        </div>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!--mention Graph-->

                <div class="mention-graph-sec">
                    <div class="spinner-border" [style.display]="mmapLoading ? 'block' : 'none'"></div>
                    <div class="mention-title"><i class="fa fa-bar-chart"></i><h2 class="">Mentions</h2></div>
                    <div class="chart-sec">
                        <canvas baseChart
                                [datasets]="lineChartData"
                                [options]="lineChartOptions"
                                [colors]="lineChartColors"
                                [legend]="lineChartLegend"
                                [chartType]="lineChartType"
                                [plugins]="lineChartPlugins">
                        </canvas>
                    </div>
                </div>

                <!--social media res-->

                <div class="mention-graph-sec">
                    <div class="spinner-border" [style.display]="smmapLoading ? 'block' : 'none'"></div>
                    <div class="mention-title"><i class="fa fa-wifi"></i><h2 class="">Social Media Mentions</h2></div>
                    <div class="chart-sec">
                        <canvas baseChart
                                [datasets]="smLineChartData"
                                [options]="lineChartOptions"
                                [colors]="lineChartColors"
                                [legend]="lineChartLegend"
                                [chartType]="lineChartType"
                                [plugins]="lineChartPlugins">
                        </canvas>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!--second row--->

    <div class="row mt-4">
        <div class="col-md-9">
            <div class="summary-mentions">
                <div class="spinner-border" [style.display]="profilesLoading ? 'block' : 'none'"></div>
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" data-toggle="tab" id="public-tab" href="#public" role="tab"><span><i class="fa fa-bullseye"></i>
                            </span>Top public profiles</a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" data-toggle="tab" id="most-tab"  href="#most" role="tab"><span><i class="fa fa-volume-up"></i>
                            </span>The most influential sites</a>
                    </li>
                </ul>

                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="public" role="tabpanel" aria-labelledby="public-tab">
                        <div class="pop-content pub-content">
                            <div class="pre-loader">
                                <ul>
                                    <li *ngFor="let mention of top_profile_mentions; let i = index">
                                        <div class="li_sec1">
                                            <a href="" class="">
                                                <div class="pub-img">
                                                    <img src="assets/images/chro.png">
                                                </div>
                                                <p><a target="_blank" href="{{mention.profile_link}}">{{mention.name}}</a></p>
                                            </a>
                                        </div>
                                        <div class="share-sec li_sec2">
                                            <div class="sh_icon"><i class="fa fa-star-o"></i></div>
                                            <div class="value">
                                                <h3>{{mention.mEngagement}}</h3>
                                                <h6>Share</h6>
                                            </div>
                                        </div>
                                        <div class="share-sec li_sec3">
                                            <div class="sh_icon"><i class="fa fa-rss"></i></div>
                                            <div class="value">
                                                <h3>{{mention.statuses_count ? mention.statuses_count : mention.mRank ? mention.mRank : mention.followers_count}}</h3>
                                                <h6>{{mention.statuses_count ? 'Posts' : mention.mRank ? 'Rank' : 'Followers'}}</h6>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!--<div class="panel-footer"><a href="" class="more-results"><span>More mentions</span></a></div>-->
                        </div>
                    </div>

                    <!---latest-tab--->

                    <div class="tab-pane fade" id="most" role="tabpanel" aria-labelledby="most-tab">
                        <div class="latest-content pub-content">
                            <div class="pre-loader">
                                <ul>
                                    <li *ngFor="let mention of top_site_mentions; let i = index">
                                        <div class="li_sec1">
                                            <p><a href="{{mention.profile_link != null ? mention.link : mention.link}}" target="_blank">{{mention.profile_link != null ? mention.profile_link.split("/")[2] : mention.link.split("/")[2]}}</a></p>
                                        </div>
                                        <div class="share-sec li_sec2">
                                            <div class="sh_icon"><i class="fa fa-comments-o"></i></div>
                                            <div class="value">
                                                <h3>{{mention.total_count}}</h3>
                                                <h6>Mentions</h6>
                                            </div>
                                        </div>
                                        <div class="share-sec li_sec3">
                                            <div class="sh_icon"><i class="fa fa-eye"></i></div>
                                            <div class="value">
                                                <h3>{{mention.profile_followers_atpost ? mention.profile_followers_atpost : 0}}</h3>
                                                <h6>Visits</h6>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!--<div class="panel-footer"><a href="" class="more-results"><span>More mentions</span></a></div>-->
                        </div>
                    </div>

                </div>


            </div>

        </div>
      
        <div class="col-md-3">
            <div class="summary-statics">
                <div class="spinner-border"></div>
                <div class="summary-title"><i class="fa  fa-share-alt"></i><h2>Sources</h2></div>
                <div class="stats-sec">
                    <ul>
                        <li *ngIf="total_per_sm.twitter != 'denied'">
                            <div class="item-value">
                                <div class="stats-detail">
                                    <div class="sta-fx">
                                        <i class="fa fa-heart-o"></i>
                                        <div class="stats-det-value">
                                            <div class="stats-value-num">
                                                <span class="details-current" [innerHtml]="total_per_sm.twitter"></span>
                                                <!--<span class="details-indicator">+125%</span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="value-lbl">Twitter</div>
                                </div>
                            </div>
                        </li>
                        <li *ngIf="total_per_sm.instagram != 'denied'">
                            <div class="item-value">
                                <div class="stats-detail">
                                    <div class="sta-fx">
                                        <i class="fa fa-heart-o"></i>
                                        <div class="stats-det-value">
                                            <div class="stats-value-num">
                                                <span class="details-current" [innerHtml]="total_per_sm.instagram"></span>
                                                <!--<span class="details-indicator">+125%</span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="value-lbl">Instagram</div>
                                </div>
                            </div>
                        </li>
                        <li *ngIf="total_per_sm.facebook != 'denied'">
                            <div class="item-value">
                                <div class="stats-detail">
                                    <div class="sta-fx">
                                        <i class="fa fa-heart-o"></i>
                                        <div class="stats-det-value">
                                            <div class="stats-value-num">
                                                <span class="details-current" [innerHtml]="total_per_sm.facebook"></span>
                                                <!--<span class="details-indicator">+125%</span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="value-lbl">Facebook</div>
                                </div>
                            </div>
                        </li>
                        <li *ngIf="total_per_sm.youtube != 'denied'">
                            <div class="item-value">
                                <div class="stats-detail">
                                    <div class="sta-fx">
                                        <i class="fa fa-heart-o"></i>
                                        <div class="stats-det-value">
                                            <div class="stats-value-num">
                                                <span class="details-current" [innerHtml]="total_per_sm.youtube"></span>
                                                <!--<span class="details-indicator">+125%</span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="value-lbl">YouTube</div>
                                </div>
                            </div>
                        </li>
                        <li *ngIf="total_per_sm.web != 'denied'">
                            <div class="item-value">
                                <div class="stats-detail">
                                    <div class="sta-fx">
                                        <i class="fa fa-heart-o"></i>
                                        <div class="stats-det-value">
                                            <div class="stats-value-num">
                                                <span class="details-current" [innerHtml]="total_per_sm.web"></span>
                                                <!--<span class="details-indicator">+125%</span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="value-lbl">Web</div>
                                </div>
                            </div>
                        </li>
                        <li *ngIf="total_per_sm.others != 'denied'">
                            <div class="item-value">
                                <div class="stats-detail">
                                    <div class="sta-fx">
                                        <i class="fa fa-heart-o"></i>
                                        <div class="stats-det-value">
                                            <div class="stats-value-num">
                                                <span class="details-current" [innerHtml]="total_per_sm.linkedin"></span>
                                                <!--<span class="details-indicator">+125%</span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="value-lbl">Linkedin</div>
                                </div>
                            </div>
                        </li>
                        <li *ngIf="total_per_sm.others != 'denied'">
                            <div class="item-value">
                                <div class="stats-detail">
                                    <div class="sta-fx">
                                        <i class="fa fa-heart-o"></i>
                                        <div class="stats-det-value">
                                            <div class="stats-value-num">
                                                <span class="details-current" [innerHtml]="total_per_sm.reddit"></span>
                                                <!--<span class="details-indicator">+125%</span>-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="value-lbl">Others</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!--<div class="panel-footer"><a href="" class="more-results"><span>More mentions</span></a></div>-->
            </div>
        </div>
    </div>


</div>
<app-footer></app-footer>
